import React from 'react';

const HERO_TAG = 'A full stack developer';
const HERO_TITLE = 'Welcome to my world';
const HERO_SUBTITLE = 'A place where I push all the cool stuff I build. I code and sometimes I vibe-code XD.';

export default function Hero() {
  return (
    <section className="hero">
      <p className="hero-tag">{HERO_TAG}</p>
      <h1>{HERO_TITLE}</h1>
      <p className="hero-subtitle">{HERO_SUBTITLE}</p>
    </section>
  );
}

